import styled from 'theme';

export const RecaptchaPolicyWrapper = styled.p`
  font-size: 0.7rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  color: ${props => props.theme.variables.colors.midGrey};

  a {
    color: ${props => props.theme.variables.colors.red};

    &:hover {
      text-decoration: underline;
    }
  }
`;
